module.exports = __webpack_public_path__ + "img/图片2-2.e0cdb35d.png";